/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as deviceV1 from "./keyapis_device_device_v1.pb"

/**
 * Сервис реализует функционал управления SIP-трубками
 */

/**
 * Сервис управления SIP-трубками
 */
export class SipPhoneServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения SIP-трубки по идентификатору.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetSipPhone = (req: GetSipPhoneRequestDto, init?: RequestInit): Promise<GetSipPhoneResponseDto> => {
    return fm.request<GetSipPhoneRequestDto, GetSipPhoneResponseDto>(`${this.host}/device/api/v1/sip_phone/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка SIP-трубок.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetSipPhoneList = (req?: GetSipPhoneListRequestDto, init?: RequestInit): Promise<GetSipPhoneListResponseDto[]> => {
    return fm.list<GetSipPhoneListRequestDto, GetSipPhoneListResponseDto>(`${this.host}/device/api/v1/sip_phone/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества SIP-трубок.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetSipPhoneCount = (req?: GetSipPhoneCountRequestDto, init?: RequestInit): Promise<GetSipPhoneCountResponseDto> => {
    return fm.request<GetSipPhoneCountRequestDto, GetSipPhoneCountResponseDto>(`${this.host}/device/api/v1/sip_phone/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка SIP-трубок.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  PostSipPhoneGetList = (req?: PostSipPhoneGetListRequestDto, init?: RequestInit): Promise<PostSipPhoneGetListResponseDto> => {
    return fm.request<PostSipPhoneGetListRequestDto, PostSipPhoneGetListResponseDto>(`${this.host}/device/api/v1/sip_phone/get_list`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества SIP-трубок.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  PostSipPhoneGetCount = (req?: PostSipPhoneGetCountRequestDto, init?: RequestInit): Promise<PostSipPhoneGetCountResponseDto> => {
    return fm.request<PostSipPhoneGetCountRequestDto, PostSipPhoneGetCountResponseDto>(`${this.host}/device/api/v1/sip_phone/get_count`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник статусов SIP-трубки.
 */
export enum SipPhoneStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Активна
   */
  ACTIVE = "ACTIVE",
  /**
   * Заблокирована
   */
  BLOCKED = "BLOCKED",
}
/**
 * Справочник статусов SIP-трубки.
 */
export type SipPhoneStatusTypeResponseEnum = keyof typeof SipPhoneStatusType
/**
 * Справочник статусов SIP-трубки.
 */
export type SipPhoneStatusTypeRequestEnum = Exclude<SipPhoneStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки;
 */
export enum SipPhonePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки;
 */
export type SipPhonePagingDirectionTypeResponseEnum = keyof typeof SipPhonePagingDirectionType
/**
 * Справочник типов направлений сортировки;
 */
export type SipPhonePagingDirectionTypeRequestEnum = Exclude<SipPhonePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum SipPhonePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По статусу доступности
   */
  STATUS = "STATUS",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type SipPhonePagingOrderByTypeResponseEnum = keyof typeof SipPhonePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type SipPhonePagingOrderByTypeRequestEnum = Exclude<SipPhonePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос на получение количества SIP-трубок
 */
export type GetSipPhoneCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: SipPhoneFilterRequestDto | null
}
/**
 * Ответ на запрос количества SIP-трубок
 */
export type GetSipPhoneCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего трубок
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetSipPhoneCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества SIP-трубок
 */
export type GetSipPhoneCountResponseErrorRequestDto = {
}
/**
 * Ошибка запроса получения количества SIP-трубок
 */
export type GetSipPhoneCountResponseErrorDto = {
}
/**
 * Запрос на получение списка SIP-трубок
 */
export type GetSipPhoneListRequestDto = {
  /**
   * Фильтр
   */
  filter?: SipPhoneFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: SipPhonePagingRequestDto
}>
/**
 * Ответ на запрос списка SIP-трубок
 */
export type GetSipPhoneListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * SIP-трубка
   */
  readonly data: SipPhoneResponseDto
  /**
   * Ошибка
   */
  readonly error: GetSipPhoneListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка SIP-трубок
 */
export type GetSipPhoneListResponseErrorRequestDto = {
  /**
   * Ошибка валидации
   */
  validationError?: deviceV1.ValidationErrorRequestDto | null
}
/**
 * Ошибка запроса получения списка SIP-трубок
 */
export type GetSipPhoneListResponseErrorDto = {
  /**
   * Ошибка валидации
   */
  validationError: deviceV1.ValidationErrorResponseDto | null
}
/**
 * Запрос на получение SIP-трубки
 */
export type GetSipPhoneRequestDto = {
  /**
   * Идентификатор трубки
   */
  id: number
}
/**
 * Ответ на запрос SIP-трубки
 */
export type GetSipPhoneResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * SIP-трубка
   */
  readonly data: SipPhoneResponseDto
  /**
   * Ошибка
   */
  readonly error: GetSipPhoneResponseErrorDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetSipPhoneResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetSipPhoneResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение количества SIP-трубок
 */
export type PostSipPhoneGetCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: SipPhoneFilterRequestDto | null
}
/**
 * Ответ на запрос количества SIP-трубок
 */
export type PostSipPhoneGetCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего трубок
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: PostSipPhoneGetCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества SIP-трубок
 */
export type PostSipPhoneGetCountResponseErrorRequestDto = {
}
/**
 * Ошибка запроса получения количества SIP-трубок
 */
export type PostSipPhoneGetCountResponseErrorDto = {
}
/**
 * Запрос на получение списка SIP-трубок
 */
export type PostSipPhoneGetListRequestDto = {
  /**
   * Фильтр
   */
  filter?: SipPhoneFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: SipPhonePagingRequestDto
}>
/**
 * Ответ на запрос списка SIP-трубок
 */
export type PostSipPhoneGetListResponseDto = {
  /**
   * Список SIP-трубок
   */
  items: SipPhoneResponseDto[]
  /**
   * Ошибка
   */
  error: PostSipPhoneGetListResponseErrorDto | null
}
/**
 * Ошибка запроса получения списка SIP-трубок
 */
export type PostSipPhoneGetListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка SIP-трубок
 */
export type PostSipPhoneGetListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * SIP-трубка.
 * # Описание модели
 */
export type SipPhoneRequestDto = {
  /**
   * Идентификатор трубки.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Идентификатор квартиры.
   * # Диапазон: 0..2147483647
   */
  roomId?: number
  /**
   * SIP номер.
   * # Диапазон: 1..200
   */
  sipNumber?: string
  /**
   * Статус SIP-трубки
   */
  statusType: SipPhoneStatusTypeRequestEnum
}
/**
 * SIP-трубка.
 * # Описание модели
 */
export type SipPhoneResponseDto = {
  /**
   * Идентификатор трубки.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Идентификатор квартиры.
   * # Диапазон: 0..2147483647
   */
  roomId: number
  /**
   * SIP номер.
   * # Диапазон: 1..200
   */
  sipNumber: string
  /**
   * Статус SIP-трубки
   */
  statusType: SipPhoneStatusTypeResponseEnum
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type SipPhoneSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: SipPhoneSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type SipPhoneSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: SipPhoneSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type SipPhoneSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type SipPhoneSavingErrorConflictResponseDto = {
}
/**
 * Фильтр для SIP-трубок
 */
export type SipPhoneFilterRequestDto = {
  /**
   * Фильтр по SIP номерам
   */
  sipNumbers?: string[]
  /**
   * Фильтр по идентификаторам квартир
   */
  roomIds?: number[]
}
/**
 * Фильтр для SIP-трубок
 */
export type SipPhoneFilterResponseDto = {
  /**
   * Фильтр по SIP номерам
   */
  sipNumbers: string[]
  /**
   * Фильтр по идентификаторам квартир
   */
  roomIds: number[]
}
/**
 * Постраничный вывод
 */
export type SipPhonePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: SipPhonePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: SipPhonePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type SipPhonePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: SipPhonePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: SipPhonePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на получение количества SIP-трубок
   */
  "GetSipPhoneCountRequest": {
    "kind": "class",
    "text": "Запрос на получение количества SIP-трубок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SipPhoneFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос количества SIP-трубок
   */
  "GetSipPhoneCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос количества SIP-трубок",
    "fields": {
      /**
       * Всего трубок
       */
      "data": {
        "type": "int32",
        "text": "Всего трубок",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSipPhoneCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества SIP-трубок
   */
  "GetSipPhoneCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества SIP-трубок",
  },
  /**
   * Запрос на получение списка SIP-трубок
   */
  "GetSipPhoneListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка SIP-трубок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SipPhoneFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "SipPhonePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос списка SIP-трубок
   */
  "GetSipPhoneListResponse": {
    "kind": "class",
    "text": "Ответ на запрос списка SIP-трубок",
    "fields": {
      /**
       * SIP-трубка
       */
      "data": {
        "type": "SipPhone",
        "text": "SIP-трубка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSipPhoneListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка SIP-трубок
   */
  "GetSipPhoneListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка SIP-трубок",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validationError": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение SIP-трубки
   */
  "GetSipPhoneRequest": {
    "kind": "class",
    "text": "Запрос на получение SIP-трубки",
    "fields": {
      /**
       * Идентификатор трубки
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос SIP-трубки
   */
  "GetSipPhoneResponse": {
    "kind": "class",
    "text": "Ответ на запрос SIP-трубки",
    "fields": {
      /**
       * SIP-трубка
       */
      "data": {
        "type": "SipPhone",
        "text": "SIP-трубка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSipPhoneResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения баннера
   */
  "GetSipPhoneResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение количества SIP-трубок
   */
  "PostSipPhoneGetCountRequest": {
    "kind": "class",
    "text": "Запрос на получение количества SIP-трубок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SipPhoneFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос количества SIP-трубок
   */
  "PostSipPhoneGetCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос количества SIP-трубок",
    "fields": {
      /**
       * Всего трубок
       */
      "data": {
        "type": "int32",
        "text": "Всего трубок",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostSipPhoneGetCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества SIP-трубок
   */
  "PostSipPhoneGetCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества SIP-трубок",
  },
  /**
   * Запрос на получение списка SIP-трубок
   */
  "PostSipPhoneGetListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка SIP-трубок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SipPhoneFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "SipPhonePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос списка SIP-трубок
   */
  "PostSipPhoneGetListResponse": {
    "kind": "class",
    "text": "Ответ на запрос списка SIP-трубок",
    "fields": {
      /**
       * Список SIP-трубок
       */
      "items": {
        "type": "SipPhone",
        "text": "Список SIP-трубок",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostSipPhoneGetListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка SIP-трубок
   */
  "PostSipPhoneGetListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка SIP-трубок",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * SIP-трубка.
   * # Описание модели
   */
  "SipPhone": {
    "kind": "class",
    "text": "SIP-трубка.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор трубки.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор трубки.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор квартиры.
       * # Диапазон: 0..2147483647
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * SIP номер.
       * # Диапазон: 1..200
       */
      "sipNumber": {
        "type": "string",
        "text": "SIP номер.\n# Диапазон: 1..200",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 200,
            "message": "Значение не входит в допустимый диапазон. Максимум: 200"
          },
        }
      },
      /**
       * Статус SIP-трубки
       */
      "statusType": {
        "type": "SipPhone.StatusType",
        "text": "Статус SIP-трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "SipPhone.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "SipPhone.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at оличаются
   */
  "SipPhone.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at оличаются",
  },
  /**
   * Фильтр для SIP-трубок
   */
  "SipPhoneFilter": {
    "kind": "class",
    "text": "Фильтр для SIP-трубок",
    "fields": {
      /**
       * Фильтр по SIP номерам
       */
      "sipNumbers": {
        "type": "string",
        "text": "Фильтр по SIP номерам",
      },
      /**
       * Фильтр по идентификаторам квартир
       */
      "roomIds": {
        "type": "int32",
        "text": "Фильтр по идентификаторам квартир",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "SipPhonePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "SipPhonePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "SipPhonePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Справочник статусов SIP-трубки.
   */
  "SipPhone.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов SIP-трубки.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Активна
       */
      "ACTIVE": {
        "i": 1,
        "text": "Активна",
      },
      /**
       * Заблокирована
       */
      "BLOCKED": {
        "i": 2,
        "text": "Заблокирована",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки;
   */
  "SipPhonePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки;",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "SipPhonePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По статусу доступности
       */
      "STATUS": {
        "i": 2,
        "text": "По статусу доступности",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 4,
        "text": "Дата создания",
      },
    },
  },
}